import { render, staticRenderFns } from "./DesignationForm.vue?vue&type=template&id=a86dff1a&scoped=true"
import script from "./DesignationForm.vue?vue&type=script&lang=js"
export * from "./DesignationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86dff1a",
  null
  
)

export default component.exports